(function ($) {

  // Define activeBtn to be used as focused element.
  let activeBtn;
  // Define url params to check.
  let iframeurl = getUrlParameter('iframeurl'),
      closeiframe = getUrlParameter('closeiframe');

  /**
   * Check if url has param 'iframeurl'. if it has we load theat url modal iframe.
   */
  if(iframeurl && validateUrl(iframeurl)) {
    loadIframeModal(iframeurl);
  }
  /**
   * Check if url has param 'closeiframe=true'. if it has we close parent window modal.
   */
  if(closeiframe === 'true' && window.parent.closeIframeModal) {
    window.parent.closeIframeModal();
  }

  /**
   * Check if url contains 'https://arkiv.kulturhusetstadsteatern.se'. If so
   * we will proceed to open it as a modal iframe.
   */
  function validateUrl(Url) {
    return Url.indexOf('https://arkiv.kulturhusetstadsteatern.se') > -1;
  }

  /**
   * Links with class 'iframeModal' will be automatically opened in a modal iframe.
   */
  $(document).on("click", 'a.iframeModal', function (e) {
    e.preventDefault();
    let Url = $(this).attr('href');
    // Set activeBtn to 'this' to be able to reset focus to this element after
    // closing the modal.
    activeBtn = this;
    loadIframeModal(Url);
  });


  /**
   * Button with class 'iframeModal' will be automatically opened in a modal iframe.
   */
  $(document).on("click", 'button.iframeModal', function (e) {
    e.preventDefault();
    let Url = $(this).attr('modal-url');

    // Set activeBtn to 'this' to be able to reset focus to this element after
    // closing the modal.
    activeBtn = this;

    loadIframeModal(Url);
  });


  /**
   * Load the actual modal iframe window
   */
  function loadIframeModal (Url) {
    // Open modal iframe window.
    $('#iframe-modal').show(200);
    // Set the iframe src.
    $('#iframe-body').prop('src', Url);

    // Set tab focus on the close btn so user using tab easy can
    // access to iframe directly.
    $('#iframe-modal__close').focus();

    // Disable window scroll.
    disableScroll();
  }

  /**
   * Close modal iframe function
   */
  function closeIframeModal () {
    // Close modal iframe window.
    $('#iframe-modal').hide(200);

    // Reset the iframe src.
    $('#iframe-body').prop('src', '');

    // If activeBtn is set use it to reset focused element.
    if (activeBtn) {
      activeBtn.focus();
      // Reset the activeBtn.
      activeBtn = null;
    }

    // Enable window scroll again.
    enableScroll();

    // Remove url params when modal closes.
    cleanUrlParams();
  }
  // Attach closeIframeModal to window to be able to access if fom within an iframe.
  window.closeIframeModal = closeIframeModal;

  /**
   * Close iframe from button clese-button press.
   */
  $('button#iframe-modal__close').click(closeIframeModal);


  /**
   * Helper function to disable scroll.
   */
  function disableScroll() {
    // Add class to prevent parent window scroll in browsers.
    $('body').addClass('iframe-modal__open');

    // Get the current page scroll position
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,

    // If any scroll is attempted, set this to the previous value
    window.onscroll = function() {
      window.scrollTo(scrollLeft, scrollTop);
    };
  }
  function enableScroll() {
    // Remove class that prevents parent window scroll.
    $('body').removeClass('iframe-modal__open');
    // Rest scroll behaviour to default.
    window.onscroll = function() {};
  }

  /**
   * Helper function to get the url and parameters.
   */
  function getUrlParameter(sParam) {
    let sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        // if param 'iframeurl' return the full path including its params.
        // We also need to check for and replace the first '&' in 'iframeurl'
        // Replace that with a '?' for the iframeurl to work properly when loaded.
        // If no additional params is included in the iframe url we leave it as
        // is and return that url.
        if (sParam === 'iframeurl') {
          // Remove previous looped params from array and also remove iframeurl
          // param.
          // This will return an array of the params left in url that
          // we can use as params in 'iframeurl'.
          let iframeUrlParams = sURLVariables.splice(i + 1);

          // Build new url from existing url and params left. Add an '?' before
          // the first param to create a valid 'iframeurl' and add '&' between
          // all other params.
          if (iframeUrlParams) {
            let iframeParamsSring = '?' + iframeUrlParams.join(['&']);
            return sParameterName[1].length > 0 ? decodeURIComponent(sParameterName[1] + iframeParamsSring) : false;
          }
        }
        return sParameterName[1].length > 0 ? decodeURIComponent(sParameterName[1]) : false;
      }
    }
    return false;
  }

  /**
   * Helper function to to remove url params if they exist.
   */
  function cleanUrlParams() {
        // Get url
    let currentUrl = (window.location.href),
        //The URL ( decode it just for GOOD practice)
        decodedUrl = decodeURI(currentUrl),
        //here we do the splitting
        splittedParts = decodedUrl.split("?"),
        // the first part of the array will be URL we will keep.
        urlToKeep = splittedParts[0],
        // the second part of the array will be the Query String to remove
        urlQuery = splittedParts[1];

    if (urlQuery) {
      window.history.replaceState({}, document.title, urlToKeep);
    }
  }

})(jQuery);
